module.exports = __webpack_public_path__ + "media/images/avatar-103c2c4f4550114b1214714832a790b1.png";